var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.064 10.371c0 .41.32.8.86.8.28 0 .51-.15.72-.32l10.01-8.399c.219-.2.489-.2.709 0l10.009 8.4c.2.17.43.32.71.32.47 0 .85-.29.85-.77 0-.3-.1-.5-.31-.68l-2.8-2.36v-4c0-.44-.28-.72-.72-.72h-1.07c-.43 0-.72.28-.72.72v1.89l-5.1-4.28c-.739-.63-1.659-.63-2.409 0L.384 9.722c-.22.18-.32.42-.32.65m3.12 8.92c0 1.39.84 2.209 2.25 2.209h13.148c1.41 0 2.24-.82 2.24-2.21v-7.919l-8.219-6.889c-.38-.32-.83-.31-1.2 0l-8.219 6.89zm11.389.6h-5.16v-6.61c0-.46.31-.76.77-.76h3.63c.46 0 .76.3.76.76z"
  })));
};
export default SvgHome;